import { PermissionRules } from '@teamworksdev/influencer/core';
import { isAgent, isBrandUser, isTeamUser } from './roles';

const hasMyProfile = PermissionRules.or(
	isAgent,
	isBrandUser,
	isTeamUser,
);

const accessProfile = hasMyProfile;

export {
	accessProfile,
};
